import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { WAREHOUSE_SEARCH_COLUMNS } from "./consts";
import { WarehouseSearchResultsProps } from "./types";
import { useTranslate } from "helpers";


const WarehouseSearchResults: React.FC<WarehouseSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onEmailClick,
    onPhoneClick,
    onGoogleMapClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={WAREHOUSE_SEARCH_COLUMNS(t, onDeleteClick, onEmailClick, onPhoneClick, onGoogleMapClick)}
        data={searchResults.data}
        selectableRows={false}
        selectedRows={selectedRows}
        showSelectAll={false}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }

        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        size="full"
      />
    </>
  );
};
export default memo(WarehouseSearchResults);
